var WAX_BASE='https://lamoussetache.com/collections/catalogue-de-wax/products/';
var OTHER_BASE='https://lamoussetache.com/collections/catalogue-de-tissus-pour-vos-projets-sur-mesure/products/';
var WAX=[];
var OTHER=[];
var ALL=[];
var curTab='wax',curFilter='tous';
var assos=[{name:'Association 1',items:[]}];
var curAsso=0;
var CHK='<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
var X='<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

function fetchPage(handle, page) {
  return fetch('/collections/'+handle+'/products.json?limit=250&page='+page)
    .then(function(r){return r.json();});
}

function loadAll(handle, page, acc) {
  page = page || 1;
  acc = acc || [];
  return fetchPage(handle, page).then(function(data) {
    var products = data.products || [];
    products.forEach(function(p) {
      var base = handle === 'catalogue-de-wax' ? WAX_BASE : OTHER_BASE;
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var tags = p.tags ? (typeof p.tags === 'string' ? p.tags.split(', ') : p.tags) : [];
      acc.push({
        id: p.handle,
        t: p.title.replace(/•\s*version\s*\d+/gi,'').replace(/•/g,'').trim(),
        tags: tags,
        img: img,
        base: base
      });
    });
    if (products.length === 250) {
      return loadAll(handle, page + 1, acc);
    }
    return acc;
  });
}

function init() {
  Promise.all([
    loadAll('catalogue-de-wax'),
    loadAll('catalogue-de-tissus-pour-vos-projets-sur-mesure')
  ]).then(function(results) {
    WAX = results[0];
    OTHER = results[1];
    ALL = WAX.concat(OTHER);
    renderAssoTabs();
    renderWax();
    renderOther();
  }).catch(function(err){
    console.error('Erreur chargement tissus:', err);
  });
}

function switchTab(tab,btn){
  curTab=tab;
  document.querySelectorAll('.cat-tab').forEach(function(t){t.classList.remove('active')});
  btn.classList.add('active');
  document.getElementById('grid-wax').classList.toggle('hidden',tab!=='wax');
  document.getElementById('grid-other').classList.toggle('hidden',tab!=='other');
  document.getElementById('filters-wax').classList.toggle('hidden',tab!=='wax');
  document.getElementById('filters-other').classList.toggle('hidden',tab!=='other');
}
function fw(c,btn){
  curFilter=c;
  document.querySelectorAll('#filters-wax .fb').forEach(function(b){b.classList.remove('active')});
  btn.classList.add('active');
  renderWax();
}
function isSelected(id){return assos[curAsso].items.some(function(x){return x.id===id})}
function swatchHTML(f){
  var s=isSelected(f.id);
  return '<div class="swatch'+(s?' selected':'')+'" onclick="toggle(\''+f.id+'\')" title="'+f.t+'">'
    +'<img src="'+f.img+'" alt="'+f.t+'" loading="lazy">'
    +'<div class="swatch-check">'+CHK+'</div>'
    +'<div class="swatch-label">'+f.t+'</div>'
    +'</div>';
}
function renderWax(){
  var list=curFilter==='tous'?WAX:WAX.filter(function(f){return f.tags&&f.tags.indexOf(curFilter)>-1});
  document.getElementById('grid-wax').innerHTML=list.length
    ?list.map(function(f){return swatchHTML(f)}).join('')
    :'<p class="no-results">Aucun tissu dans cette couleur</p>';
}
function renderOther(){
  document.getElementById('grid-other').innerHTML=OTHER.map(function(f){return swatchHTML(f)}).join('');
}
function toggle(id){
  var f=ALL.find(function(x){return x.id===id});
  var items=assos[curAsso].items;
  var idx=items.findIndex(function(x){return x.id===id});
  if(idx>-1){items.splice(idx,1);}
  else{items.push({id:f.id,t:f.t,img:f.img,base:f.base});}
  renderWax();renderOther();renderMB();
}
function removeTile(id){
  assos[curAsso].items=assos[curAsso].items.filter(function(x){return x.id!==id});
  renderWax();renderOther();renderMB();
}
function renderMB(){
  var items=assos[curAsso].items;
  var n=items.length;
  var zone=document.getElementById('mb-zone');
  zone.classList.toggle('has-items',n>0);
  document.getElementById('mb-empty').style.display=n?'none':'flex';
  document.getElementById('mb-actions').classList.toggle('hidden',n===0);
  zone.querySelectorAll('.mb-tile').forEach(function(e){e.remove()});
  items.forEach(function(f){
    var div=document.createElement('div');
    div.className='mb-tile';
    div.innerHTML='<img src="'+f.img+'" alt="'+f.t+'">'
      +'<button class="mb-remove" onclick="removeTile(\''+f.id+'\')" aria-label="Retirer">'+X+'</button>'
      +'<div class="mb-tile-footer">'
      +'<span class="mb-tile-name">'+f.t+'</span>'
      +'<button class="mb-tile-link" onclick="openModal(\''+f.id+'\')">Voir</button>'
      +'</div>';
    zone.appendChild(div);
  });
}
function openModal(id){
  var f=ALL.find(function(x){return x.id===id});
  document.getElementById('modal-img').src=f.img;
  document.getElementById('modal-img').alt=f.t;
  document.getElementById('modal-name').textContent=f.t;
  var link=document.getElementById('modal-link'); link.href=f.base+id; link.target='_blank';
  document.getElementById('lmt-modal').classList.remove('hidden');
}
function closeModal(){document.getElementById('lmt-modal').classList.add('hidden')}
function renderAssoTabs(){
  var bar=document.getElementById('asso-bar');
  bar.innerHTML=assos.map(function(a,i){
    return '<button class="asso-tab'+(i===curAsso?' active':'')+'" onclick="switchAsso('+i+')">'+a.name+'</button>';
  }).join('')+'<button class="asso-tab-add" onclick="addAsso()" title="Nouvelle association">+</button>';
}
function switchAsso(i){curAsso=i;renderAssoTabs();renderWax();renderOther();renderMB();}
function addAsso(){
  assos.push({name:'Association '+(assos.length+1),items:[]});
  curAsso=assos.length-1;renderAssoTabs();renderWax();renderOther();renderMB();
}
function clearAsso(){assos[curAsso].items=[];renderWax();renderOther();renderMB();}
function openForm(){
  var items=assos[curAsso].items;
  var tissus=items.map(function(f){return f.t}).join(', ');
  window.open('/pages/contact','_blank');
}
function downloadPDF(){
  var items=assos[curAsso].items;
  var tilesHTML=items.map(function(f){
    return '<div style="width:170px;display:flex;flex-direction:column">'
      +'<img src="'+f.img+'" alt="'+f.t+'" style="width:170px;height:213px;object-fit:cover;display:block;-webkit-print-color-adjust:exact;print-color-adjust:exact">'
      +'<div style="font-size:9px;text-align:center;margin-top:0;text-transform:uppercase;letter-spacing:.08em;color:#202020">'+f.t+'</div>'
      +'</div>';
  }).join('');
  var html='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Mon association de tissus - La Mousse Tache</title>'
    +'<style>'
    +'@page{size:A4 portrait;margin:.8cm}'
    +'*{box-sizing:border-box;margin:0;padding:0}'
    +'body{font-family:"Nunito Sans","Helvetica Neue",sans-serif;background:white;min-height:calc(297mm - 1.6cm);display:flex;flex-direction:column}'
    +'.tiles{display:flex;flex-wrap:wrap;gap:8px;justify-content:flex-start;flex:1;align-content:flex-start}'
    +'.footer{text-align:center;padding-top:1.2rem;font-size:9px;color:#1e72de;letter-spacing:.1em}'
    +'</style>'
    +'</head><body onload="window.print()">'
    +'<div class="tiles">'+tilesHTML+'</div>'
    +'<div class="footer">lamoussetache.com</div>'
    +'</body></html>';
  var w=window.open('','_blank','width=800,height=600');
  if(w){w.document.write(html);w.document.close();}
  else{alert('Autorisez les popups pour ce site pour télécharger le PDF.');}
}

init();